export enum District {
  KOH_PHANGAN = 'KOH_PHANGAN',

  BAN_TAI = 'BAN_TAI',

  BAN_NUEA = 'BAN_NUEA',

  KOH_TAO = 'KOH_TAO',
}
